module.exports = __webpack_public_path__ + "img/SwissTrust5.05f48a76.png";